import { invoices } from "../../constants/actionTypes";

const generateInvoice = (data) => ({
  type: invoices.GENERATE_INVOICE,
  payload: data,
});

const successGenerateInvoice = (data) => ({
  type: invoices.SUCCESS_GENERATE_INVOICE,
  payload: data,
});

const errorGenerateInvoice = (data) => ({
  type: invoices.ERROR_GENERATE_INVOICE,
  payload: data,
});

const getInvoiceListDataPaginated = (data) => ({
  type: invoices.GET_INVOICES_LIST,
  payload: data,
});

const setInvoiceListSuccess = (data) => ({
  type: invoices.SET_INVOICES_LIST_SUCCESS,
  payload: data,
});

const setInvoiceListError = (data) => ({
  type: invoices.SET_INVOICES_LIST_ERROR,
  payload: data,
});

const uploadInvoiceJson = (data) => ({
  type: invoices.UPLOAD_INVOICE_JSON,
  payload: data,
});
const uploadInvoiceJsonSuccess = (data) => ({
  type: invoices.UPLOAD_INVOICE_JSON_SUCCESS,
  payload: data,
});
const uploadInvoiceJsonError = (data) => ({
  type: invoices.UPLOAD_INVOICE_JSON_ERROR,
  payload: data,
});
const updateInvoicePaymentStatus = (invoiceId, data) => ({
  type: invoices.UPDATE_INVOICE_PAYMENT_STATUS,
  payload: { invoiceId, data },
});
const updateInvoicePaymentStatusSuccess = (data) => ({
  type: invoices.UPDATE_INVOICE_PAYMENT_STATUS_SUCCESS,
  payload: data,
});
const updateInvoicePaymentStatusError = (data) => ({
  type: invoices.UPDATE_INVOICE_PAYMENT_STATUS_ERROR,
  payload: data,
});

export {
  generateInvoice,
  successGenerateInvoice,
  errorGenerateInvoice,
  getInvoiceListDataPaginated,
  setInvoiceListSuccess,
  setInvoiceListError,
  uploadInvoiceJson,
  uploadInvoiceJsonSuccess,
  uploadInvoiceJsonError,
  updateInvoicePaymentStatus,
  updateInvoicePaymentStatusSuccess,
  updateInvoicePaymentStatusError,
};
